import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { WelcomeComponent } from './welcome/welcome.component';
import { SurveyComponent } from './survey/survey.component';
import { CompleteComponent } from './complete/complete.component';
import { SelectionComponent } from './selection/selection.component';

const routes: Routes = [
  { 
    // Links returning to survey
    path: 'survey/:id',
    component: SurveyComponent,
  },
  { 
    // Direct links
    path: ':type/:id',
    component: WelcomeComponent,
  },
  { 
    // IDF Patient Survey direct link
    path: 'idf',
    redirectTo: '/ipa/58613-1459',
    pathMatch: 'full', 
  },
  {
    path: '',
    redirectTo: 'welcome',
    pathMatch: 'full'
  },
  { 
    path: 'welcome',
    component: WelcomeComponent,
  },
  { 
    path: 'complete',
    component: CompleteComponent,
  },
  { 
    path: 'ed-census',
    component: SelectionComponent, 
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }